export const isApiResponseSuccessful = (response = {}) =>
  response?.success === true && String(response?.code) === "1";

export const unwrapApiResponse = (response = {}) => {
  if (isApiResponseSuccessful(response)) return response;

  const fallbackMessage =
    response?.success === true ? "接口返回异常" : "接口调用失败";
  const error = new Error(response?.message || response?.msg || fallbackMessage);
  error.name = "ApiResponseError";
  error.code = response?.code;
  error.responseData = response;
  throw error;
};
